import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {PageManager} from "../../../../shared/interface/page-manager";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {FileManagerPageService} from "../../../../shared/services/file-manager-page.service";

@Component({
  selector: 'app-page-details',
  templateUrl: './page-details.component.html',
  styleUrls: ['./page-details.component.scss']
})
export class PageDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  pageId: string;
  pageObject?: PageManager;
  page: ReplaySubject<PageManager> = new ReplaySubject<PageManager>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private fileManagerPageService: FileManagerPageService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }


  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.pageId = params.id;
        this.loadPage();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadPage(): void {
    this.fileManagerPageService.get(this.pageId).subscribe((page: PageManager) => {
      this.page.next(page);
      this.pageObject = page;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
